import _ from 'lodash';

import { UserStatus, UserStatusLabels } from 'constants/telephony';
import { COLOR_PALETTE } from 'constants/ui';

import { TAB_CONFIG } from './TelephonyWidget.constants';

export const getVisibleTabs = masterRoles => {
  const normalizedRoles = (Array.isArray(masterRoles) ? masterRoles : []).map(role =>
    _.toLower(role),
  );

  return TAB_CONFIG.filter(tab => {
    if (!tab.requiredRoles) {
      return true;
    }

    return tab.requiredRoles.some(requiredRole => normalizedRoles.includes(requiredRole));
  });
};

const STATUS_COLOR_MAP = {
  [UserStatus.AVAILABLE]: COLOR_PALETTE.GREEN[7],
  [UserStatus.UNAVAILABLE]: COLOR_PALETTE.RED[6],
  [UserStatus.OUT_OF_OFFICE]: COLOR_PALETTE.ORANGE[6],
  [UserStatus.ON_CALL]: COLOR_PALETTE.BRAND[6],
  [UserStatus.LEAD_QUIET_TIME]: COLOR_PALETTE.GRAY[6],
};

export const getStatusColor = status => STATUS_COLOR_MAP[status] ?? COLOR_PALETTE.GRAY[6];

export const getStatusOptions = isLoanOfficer =>
  Object.values(UserStatus)
    .filter(
      status =>
        status !== UserStatus.ON_CALL && (status !== UserStatus.LEAD_QUIET_TIME || isLoanOfficer),
    )
    .map(status => ({
      value: status,
      label: UserStatusLabels[status],
      color: STATUS_COLOR_MAP[status],
    }));
